<template>
  <div class="content">
    <card>
      <div class="row">
        <!-- 상태 필터 -->
        <div class="col-md-3">
          <el-select @change="getSites" class="select-primary" size="large" placeholder="상태" v-model="state.state">
            <el-option v-for="option in state.options" :value="option.value" :label="option.label" :key="option.label" />
          </el-select>
        </div>

        <!-- 타입 필터 추가 -->
        <div class="col-md-3">
          <el-select @change="getSites" class="select-primary" size="large" placeholder="타입" v-model="type">
            <el-option label="전체" :value="null" />
            <el-option label="헤드" value="head" />
            <el-option label="하단" value="normal" />
          </el-select>
        </div>

        <div v-if="state.state === 1" class="col-md-3">
          <base-button @click="setSiteOrder" type="default">노출순서변경</base-button>
          <el-popover trigger="hover" placement="top">
            <div>
              <div class="popover-body">드래그앤드랍으로 노출순서를 변경할 수 있습니다</div>
            </div>
            <base-button slot="reference"> ? </base-button>
          </el-popover>
        </div>
        <base-button @click="goSiteForm()" type="default">사이트 등록</base-button>
      </div>
    </card>
    <draggable class="row" v-model="sites" group="people" @start="drag = true" @end="drag = false">
      <div class="col-sm-3" v-for="(item, index) in sites">
        <card class="card">
          <div class="row">
            <template v-if="item.type !== 'head'">
              <img v-if="item.imageFileUrl" slot="image" class="card-img-top cover-img" :src="item.imageFileUrl" />
              <img v-else src="@/assets/img/blip-logo.png" />
            </template>
          </div>
          <p>{{ item.typeName }}</p>

          <!-- 타입 태그 + 아이콘 -->
          <p>
            <span
              class="type-tag"
              :class="{
                head: item.type === 'head',
                mission: item.type === 'mission',
                normal: item.type === 'normal',
              }"
            >
              <i v-if="item.type === 'head'" class="el-icon-star-off"></i>
              <i v-if="item.type === 'mission'" class="el-icon-s-flag"></i>
              <i v-if="item.type === 'normal'" class="el-icon-document"></i>
              {{ getDisplayType(item.type) }}
            </span>
          </p>

          <!-- 헤드일 때 제목 숨기기 -->
          <p v-if="item.type !== 'head'">{{ item.title.ko }}</p>
          <p class="card-text">{{ item.startTime }}</p>
          <p>{{ item.endTime }}</p>
          <base-button @click="goSiteForm(item.id)" type="default">상세</base-button>
        </card>
      </div>
    </draggable>
  </div>
</template>
<script>
import { BaseButton, Card } from "@/components/index";
import draggable from "vuedraggable";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    Card,
    BaseButton,
    draggable,
  },
  async created() {
    await this.getSites();
  },
  data() {
    return {
      state: {
        state: 1,
        options: [
          { label: "전체", value: null },
          { label: "표시", value: 1 },
          { label: "숨김", value: 0 },
        ],
      },
      type: null,
      sites: [],
    };
  },
  methods: {
    getDisplayType(type) {
      const map = {
        head: "헤드",
        mission: "미션",
        normal: "일반",
      };
      return map[type] ?? type;
    },
    async getSites() {
      let typeParam = this.type;

      // 일반(normal)을 선택하면 normal + mission 둘 다 조회
      if (this.type === "normal") {
        typeParam = ["normal", "mission"];
      }

      return this.$axios.get(`/home/sites`, { params: { state: this.state.state, type: typeParam } }).then((res) => {
        this.sites = res.data.data.map((site) => {
          site.imageFileUrl = window.Endpoints.imageServerUrl + site.imageFileId;
          site.startTime = formatDateTime(site.startTime);
          site.endTime = formatDateTime(site.endTime);
          return site;
        });
      });
    },
    async setSiteOrder() {
      const sites = [];
      this.sites.forEach((site, order) => {
        sites.push({ siteId: site.id, order });
      });
      return this.$axios.put("/home/sites/order", { sites }).then((res) => {
        window.Toast.success("미션의 노출순서가 변경되었습니다");
        this.getSites();
      });
    },
    goSiteForm(siteId) {
      if (siteId) {
        this.$router.push(`/home/siteForm?siteId=${siteId}`);
      } else {
        this.$router.push(`/home/siteForm`);
      }
    },
  },
};
</script>
<style scoped>
.type-tag {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.type-tag.head {
  background-color: #ffe3e3;
  color: #d60000;
}

.type-tag.mission {
  background-color: #e8f3ff;
  color: #0066ff;
}

.type-tag.normal {
  background-color: #e9f5e9;
  color: #128a00;
}
</style>
